
import React, { forwardRef } from "react"
import { Form, Alert } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import './PeriodDateRange.css'

const PeriodDateRange = ({start, setStart, end, setEnd, startError = '', endError = ''}) => {

  const Input = forwardRef( ({ value, onClick, id, className, ...rest }, ref) => 
    (<input id={id} name={id} type="text" className={"form-control text-center " + className} ref={ref} value={value} onClick={onClick} {...rest} />)
  )

  return (
    <Form.Row className="row justify-content-around periodDateRangeRow">
      <Form.Group className="col-auto bg-white">
          <Form.Label htmlFor="period-startDate">Inicio</Form.Label>
            <DatePicker
              id="period-startDate" 
              dateFormat="dd-MM-yyyy"
              isClearable
              locale='es'
              selected={start} onChange={setStart} 
              selectsStart startDate={start} endDate={end}
              maxDate={end}
              placeholderText="DD/MM/YYYY"
              popperPlacement="bottom-center"
              customInput={<Input />}
            />
          {startError && <Alert variant='danger' className='mt-2'>{startError}</Alert>}
      </Form.Group>
      <Form.Group className="col-auto bg-white">
          <Form.Label htmlFor="period-endDate">Fin</Form.Label>
            <DatePicker
              id="period-endDate"
              dateFormat="dd-MM-yyyy"
              isClearable
              locale='es'
              selected={end} onChange={setEnd}
              selectsEnd startDate={start} endDate={end}
              minDate={start}
              placeholderText="DD/MM/YYYY"
              popperPlacement="bottom-center"
              customInput={<Input />}
            />
          {endError && <Alert variant='danger' className='mt-2'>{endError}</Alert>}
      </Form.Group>
    </Form.Row>
  )
}

export default PeriodDateRange